import React from "react";
import Modal from "../../../../components/elements/Modal";

import ManagePlan from "../ManagePlan.js";
import DrawerHeader from "../../../../components/elements/DrawerHeader.js";
import Drawer from "../../../../components/elements/Drawer.js";

const ManagePlanModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    //   <Modal
    //     isOpen={open}
    //     setIsOpen={close}
    //     size="xl2"
    //     title={data?._id ? "Update" : "Create New "}
    //   >
    //     <ManagePlan getResponse={getResponse} close={close} data={data} />
    //   </Modal>
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl"}
      title={data?._id ? "Update" : "Create New "}
      subtitle="View, update and modify plan details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      header={<DrawerHeader />}
    >
      <ManagePlan getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManagePlanModal;
